import React, { useState } from "react";
import Modal from "olive-react-myoneui/lib/Modal";
import Button from "olive-react-myoneui/lib/Button";
import Dropdown from "olive-react-myoneui/lib/Dropdown";
import DeleteModal from "./DeleteModal";
import iconDocx from "../../../../assets/img/docx.png";
import {
  certiIcon,
  documentIcon,
  downloadBaseIcon,
  binIcon,
  editIcon,
} from "../../../constants/icons";

let host = window.location.protocol + "//" + window.location.host;

function ExtDocCard({
  className = "",
  docName,
  docFileName,
  uploadedDate,
  fileType,
  docType,
  id,
  accessToken,
  setShow,
  setTriggerText,
  setID,
}) {
  const [modalShow, setModalShow] = useState(false);
  const [deleteConfirmShow, setDeleteConfirmShow] = useState(false);

  const modifiedFileURL = `${docFileName}#toolbar=0&navpanes=0&scrollbar=0`;

  const downloadFile = async () => {
    try {
      const response = await fetch(docFileName);
      const blob = await response.blob();
  
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
  
      let extension = "pdf"; // default
      if (fileType === "image") {
        extension = docFileName.split(".").pop().toLowerCase();
      } else if (fileType === "doc" || fileType === "docx") {
        extension = fileType;
      }
  
      anchor.download = `${docName}.${extension}`;
      anchor.style.display = "none";
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
  
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed", err);
    }
  };

  const renderFile = () => {
    if (fileType === "image") {
      return <img src={docFileName} alt="Certificate" className="img-fluid" />;
    } else if (fileType === "pdf") {
      return (
        <iframe
          src={modifiedFileURL}
          title={docName}
          width="100%"
          height="128px"
        ></iframe>
      );
    } else if (fileType === "doc" || fileType === "docx") {
      return (
        <div className="doc-icon-wrapper">
          <img src={iconDocx} alt="Docx" className="img-fluid" />
          <p>Preview Not Available</p>
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <>
      <div
        className={`myk__stu-doc-item d-flex align-items-center justify-content-between gap-2 ${className}`}
      >
        <div
          className="myk__stu-doc d-flex align-items-center"
          onClick={() => setModalShow(true)}
        >
          <div
            className={`myk__stu-doc-icon me-2 ${
              docType === "certificate" ? "icon-certificate" : "icon-document"
            }`}
          >
            {docType === "certificate" ? certiIcon : documentIcon}
          </div>
          <div className="myk__stu-doc-meta">
            <h3>{docName}</h3>
            <p>{uploadedDate}</p>
          </div>
        </div>
        <div className="myk__stu-doc-action">
          <Dropdown
            className={`ext_docs-options dots-dropdown dropdown-select text-end`}
            align="end"
          >
            <Dropdown.Toggle
              as="div"
              role="button"
              tabIndex={0}
              className="btn btn-icon rounded-circle"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-three-dots"
                viewBox="0 0 16 16"
              >
                <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu mw-dropdown-default">
              <Dropdown.Item
                eventKey="1"
                onClick={() => {
                  setShow(true);
                  setTriggerText("Edit");
                  setID(id);
                }}
              >
                {editIcon} Edit
              </Dropdown.Item>
              <Dropdown.Item
                eventKey="2"
                className="text-danger"
                onClick={() => setDeleteConfirmShow(true)}
              >
                {binIcon} Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      {/* Modal */}
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        contentClassName="myk__certificate-modal px-0 py-3"
      >
        <Modal.Header className="justify-content-start pb-2 px-2">
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-start"
          >
            <h1>{docName}</h1>
            <p className="mb-0">
              <strong>Uploaded Date:</strong> {uploadedDate}
            </p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{renderFile()}</Modal.Body>
        <Modal.Footer className="text-end pt-3">
          <Button variant="default" onClick={() => setModalShow(false)}>
            Close
          </Button>
          <Button onClick={downloadFile}>
            {downloadBaseIcon} &nbsp; Download
          </Button>
        </Modal.Footer>
      </Modal>
      <DeleteModal
        id={id}
        accessToken={accessToken}
        show={deleteConfirmShow}
        setHide={() => setDeleteConfirmShow(false)}
      />
    </>
  );
}

export default ExtDocCard;
